<template>
    <v-list :key="copy.key" class="batch-copy-input">
      <v-list-tile class="center">
        <!-- Input field for new name -->
        <v-list-tile-content >
          <v-text-field
            v-model="copy.name"
            @input="$v.copy.name.$touch"
            class="full-width"
            counter=255
            label="Copied Bulb Name"
            placeholder="Copy Placeholder"
            :disabled="batchCopying"
            :hide-details="!$v.copy.name.$error"
            :rules="[rules.notEmpty, rules.maxLength255]"
          ></v-text-field>
        </v-list-tile-content>
        <!-- icon for deleting  -->
        <v-list-tile-avatar>
          <v-icon v-if="copyIndex > 0
            && !copy.copying
            && !copy.success
            && copy.errors.length === 0
            "
            @click='deleteCopy(copyIndex)'
            :disabled="batchCopying"
          >
            delete
          </v-icon>
          <!--progress spinner when copying-->
          <v-progress-circular
            v-if="copy.copying"
            indeterminate
            color="primary"
            :size="20"
            :width="3"
          ></v-progress-circular>
          <!-- success icon -->
          <v-icon v-if="copy.success" color="success">done</v-icon>
          <!-- error icon and popover for listed errors -->
          <v-menu offset-y v-if="copy.errors.length > 0">
            <template v-slot:activator="{ on }">
              <v-icon  color="red" v-on="on">error_outline</v-icon>
            </template>
            <v-list>
              <v-list-tile v-for="(error, index) in copy.errors" :key="index">
                <v-list-tile-avatar>
                  <v-icon color="error">error_outline</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title class='error--text'>{{ error }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-list-tile-avatar>
      </v-list-tile>
    </v-list>
</template>

<script>
/* global _ */
/* global moment */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';

import {
  required,
  maxLength
} from 'vuelidate/lib/validators';


export default {
  name: 'CopyRow',
  props: [
    'batchCopying',
    'copies',
    'copy',
    'copyIndex'
  ], 
  data() {
    return {
      rules: {
        notEmpty: value => !!value.trim().length || 'Name is required.',
        maxLength255: value => _.get(value, 'length', 0) < 255 || 'Name cannot exceed 255 characters',
      },
    }
  },
  methods: {
    deleteCopy(bulbId, copyIndex) {
      this.copies.splice(copyIndex, 1);
    },
  },
  validations: {
    copy: {
      name: {
        required,
        maxLength: maxLength(255),
      }
    }, 
  },
  watch : {
    '$v.copy.name.$error'() {
      this.copy.errors = [];
      if (!this.$v.copy.name.required) this.copy.errors.push("Name is required");
      if (!this.$v.copy.name.maxLength) this.copy.errors.push("Name cannot exceed 255 characters");
    }, 
  }
};
</script>

<style scoped>
  .v-input {
    min-height: 45px; /* removing the three-line hides the underline ::before by one pixel, this bumps it up again  */
  }
  .batch-copy-input {
    padding-left: 24px!important;
    padding-top: 8px!important;
  }
</style>
